import { TStore } from '@/store';

const isTestProject = (store: TStore) =>
  [
    'b-af298735-17c9-31e6-b0a6-2a05843aff16',
    'b-c137b5af-c264-3686-bf80-25e366e1a911',
  ].includes(store.businessId);

// 判断是否是搜狗项目
const isSgProject = (store: TStore) =>
  store.businessId === 'b-186d0fd4-3e3a-3920-b6af-d02b452c880e' ||
  isTestProject(store);

// 判断是否是视频海外版 weTV
const isWeTvProject = (store: TStore) =>
  store.productId === 'p-05d18bce-f6c2-3b24-a3ac-0d36865186d8' ||
  isTestProject(store);

// 判断是否开启问题列表的更新时间功能
const isOpenIssueListUpdateTime = (store: TStore) =>
  store.productId === 'p-8f982f89-51be-398e-95fe-d1eade7ee5c0' ||
  isTestProject(store);

// 判断是否是腾讯新闻项目
const isNewsProject = (store: TStore) =>
  store.businessId === 'b-550f4410-ae24-3173-905b-422b8c08a6bd';

// 判断是否是腾讯新闻合集和微视合集项目
const isCastratedProject = (store: TStore) =>
  // ['4nvpf1abfy', 'yfyuh68ws9'].includes(store.appId);
  // 测试环境调试, 去掉反馈合集项目的判断
  ['4nvpf1abfy', 'yfyuh68ws9', 'hwtsnb8htv'].includes(store.appId);

/** 判断模型编辑时是否应该展示关键词和图片关键词 兼容旧项目 */
const isHaveModelKeyWordByAppid = (store: TStore) =>
  [
    // 输入法_IOS
    '634fhtpfcv',
    // 输入法_Android
    'v89171a933',
    // 输入法_PC
    '86aya116jv',
    // 腾讯文档
    'v2kdwzsnbx',
    // 新闻合集
    'yfyuh68ws9',
    // 腾讯体育_IOS
    '2a198046f5',
    // 腾讯微证券
    'wzs1fmyyek',
    // 微视android
    '1f4d32bf9d',
    // 微视ios
    'ff9485ebaa',
  ].includes(store.appId);

// 判断是否是应用宝项目
const isYYBProject = (store: TStore) =>
  store.businessId === 'b-93ea52a1-9bc1-35c0-870f-2654dd166fa0';

/** 判断是否为视频项目 */
const isTV = (store: TStore) =>
  [
    'absby672c2',
    '3m8t6dfyrg',
    '10dc5f7feb',
    '0f985ef8a0',
    'a849cc6181',
    'fy4a3m1cq4',
  ].includes(store.appId);

// 判断是否是腾讯客厅tv项目
const isTencentTVProject = (store: TStore, oldAppId?: string) =>
  'tkb87vfuwg' === store.appId || oldAppId === 'tkb87vfuwg';

// 判断是否是 alpha 项目
const isAlphaProject = (store: TStore) =>
  'f31a5ac8b5' === store.appId || isTestProject(store);

/** 展示ai会话列表 */
const showAiReplyList = (store: TStore) =>
  [
    'vxdvrzffx1',
    'e0a59cb34e',
    '5848',
    '32a2a0e053',
    'v89171a933',
    '634fhtpfcv',
    '61k6j832rt',
    'd28e6131f6',
    'b59d8f4607',
  ].includes(store.appId);

// 判断是否是多应用项目
const isMultiAppProject = (store: TStore) => isTV(store);

// 判断是否是ima项目
const isImaProject = (store: TStore) => ['4jdwdvkb5b'].includes(store.appId);

/** ai客服入口白名单 */
export const showAiChat = (store: TStore) =>
  [
    'v89171a933',
    '634fhtpfcv',
    '86aya116jv',
    '5848',
    'ff9485ebaa',
    '1f4d32bf9d',
    'dd7b2b897a',
    '310ac65313',
    '32a2a0e053',
    'v89171a933',
    '634fhtpfcv',
  ].includes(store.appId);

/** 根据一级目录判断是否是腾讯视频项目 */
const isTencentTv = (id: string) =>
  id === 'p-e3f592b2-1df8-3bcb-9ea4-abc0d1b26599';

export {
  isAlphaProject,
  isCastratedProject,
  isHaveModelKeyWordByAppid,
  isImaProject,
  isMultiAppProject,
  isNewsProject,
  isOpenIssueListUpdateTime,
  isSgProject,
  isTencentTv,
  isTencentTVProject,
  isTestProject,
  isTV,
  isWeTvProject,
  isYYBProject,
  showAiReplyList,
};
